// extracted by mini-css-extract-plugin
export default {"price":"k6-z","onSale":"l6-z","msrpLabelPrice":"m6-z","msrpLabel":"n6-z","originalPrice":"o6-z","percentOff":"p6-z"};